export const bonuses = [
  {
    number: 1,
    title: "The Biomagnetism Quick Reference Vault™",
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/uGYd8aNCxJAw2p9kGLUh1w/BONUS_1_BIOMAGNETISM-EN.png",
    description:
      "A collection of educational reference sheets that helps you locate introductory concepts without searching through multiple documents.",
    items: [
      "An organized terminology guide",
      "Topic reference sheets",
      "Quick-review pages",
      "Concept summaries",
      "A printable reference index",
    ],
    why: "I wanted you to have a convenient collection of reference materials you can return to whenever you need to review a concept.",
  },
  {
    number: 2,
    title: "The Ready-to-Use Concept Map Pack™",
    value: 27,
    image: "https://cdn.magicpatterns.com/uploads/8mLHpmM7CAc6v5itfDFweU/BONUS_2_BIOMAGNETISM-EN.png",
    description: "A collection of visual resources designed to complement the main Protocol Vault.",
    items: [
      "Foundational concept maps",
      "Topic organization diagrams",
      "Visual summaries",
      "Comparison frameworks",
      "Printable study maps",
    ],
    why: "Rather than making you create your own diagrams from scratch, I've prepared visual resources you can use to organize your studies.",
  },
  {
    number: 3,
    title: "The Study Checklist Collection™",
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/j7q9ixqbzeSnqd7sjZXB65/BONUS_3_BIOMAGNETISM-EN.png",
    description: "A practical collection of checklists for organizing your educational activities.",
    items: [
      "Study preparation checklists",
      "Note organization checklists",
      "Review session checklists",
      "Progress review sheets",
      "Monthly organization checklists",
    ],
    why: "A checklist gives you a clear sequence to follow instead of relying on memory every time you organize a study session.",
  },
  {
    number: 4,
    title: "The 30-Day Study Planner™",
    value: 17,
    image: "https://cdn.magicpatterns.com/uploads/iDCPG9fkt1ayv4PyNRwvhY/BONUS_4_BIOMAGNETISM-EN.png",
    description: "A ready-made planner that complements the roadmap in Volume V.",
    items: [
      "A monthly study calendar",
      "Weekly planning sheets",
      "Daily task organizers",
      "Progress trackers",
      "Review reminders",
      "Reflection pages",
    ],
    why: "I wanted you to have a practical way to turn your study plan into an organized routine.",
  },
  {
    number: 5,
    title: "The Biomagnetism Review Cards™",
    value: 19,
    image: "https://cdn.magicpatterns.com/uploads/euasWJVgpG8sE7XCrCK2Rc/BONUS_5_BIOMAGNETISM-EN.png",
    description: "A collection of educational cards to help you review introductory concepts.",
    items: [
      "Question and answer cards",
      "Vocabulary cards",
      "Concept review prompts",
      "Printable card layouts",
      "Blank templates for your own notes",
    ],
    why: "These cards give you another way to revisit the information you're studying without having to reread entire documents.",
  },
];
